import React from 'react';
import OverlineImage from '../../../images/features/jtb/overline.png';
import UnderlineImage from '../../../images/features/jtb/underline.png';
import AppTypography from '../../core/Typography/AppTypography';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    width: '80%',
    maxWidth: 420,
    margin: 'auto',
    position: 'relative',
  },
  overline: {
    top: -30,
  },
  underline: {
    bottom: -20,
  },
  image: {
    width: '100%',
    height: 'auto',
    position: 'absolute',
    left: 0,
    right: 0,
  },
}));

const Title = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img
        src={OverlineImage}
        className={clsx(classes.image, classes.overline)}
      />
      <AppTypography
        size={{ xs: 24, sm: 28 }}
        weight="bold"
        color="palette.text.primary"
      >
        {children}
      </AppTypography>
      <img
        src={UnderlineImage}
        className={clsx(classes.image, classes.underline)}
      />
    </div>
  );
};

export default Title;
